type Props = {
  description?: string
}

const ContentBlockDescription = ({ description }: Props) => (
  <div>
    <p className="mb-4 font-bold text-grey-90 text-16">Описание</p>
    <div className="truncate whitespace-pre-line font-pro text-16">
      {description}
    </div>
  </div>
)

export default ContentBlockDescription
